import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'currencyFormatter',
})
export class CurrencyFormatterPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (args[0] === 'no-fraction') {
      return new Intl.NumberFormat(environment.currencyFormat, {
        minimumFractionDigits: 0,
      }).format(value);
    }
    return new Intl.NumberFormat(environment.currencyFormat, {
      minimumFractionDigits: 2,
    }).format(value);
  }
}
